import { Avatar, Card } from 'antd';
import { HomeOutlined, LinkOutlined, UserOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import botconfig from "../botconfig";
import { useTranslation } from "react-i18next"
export function Guild(guild) {
  const { t } = useTranslation()
  guild = guild.guild
  const buttons = []
  const localItem = JSON.parse(localStorage.getItem("wetbot"))
  if (!guild.added) buttons.push(
    <div style={{ display: "flex", gap: 5, flexWrap: "wrap", justifyContent: "center" }}>
      <Button icon={<LinkOutlined />} onClick={() => window.open(`https://discord.com/oauth2/authorize?client_id=${botconfig.botId}&guild_id=${guild.id}&permissions=412602576081&scope=bot%20applications.commands`, undefined, "popup=yes width=421 height=750")}>
        {t('Пригласить')}
      </Button>
    </div>
  )
  else {
    if (guild.permissions.find(e => e === "Administrator" || e === "ManageGuild")) {
      buttons.push(
        <div style={{ display: "flex", gap: 5, flexWrap: "wrap", justifyContent: "center" }}>
          <Button icon={<HomeOutlined />} onClick={() => {
            window.location.replace(`${botconfig.root_path}${botconfig.website_port}/dashboard/${guild.id}`)
          }}>
            {t('Панель управления')}
          </Button>
          <Button icon={<UserOutlined />} onClick={() => {
            window.location.replace(`${botconfig.root_path}${botconfig.website_port}/guilds/${guild.id}/profiles/${localItem.user.id}`)
          }}>
            {t('Профиль')}
          </Button>
        </div>
      )
    } else {
      buttons.push(
        <div style={{ display: "flex", gap: 5, flexWrap: "wrap", justifyContent: "center" }}>
          <Button icon={<UserOutlined />} onClick={() => {
            window.location.replace(`${botconfig.root_path}${botconfig.website_port}/guilds/${guild.id}/profiles/${localItem.user.id}`)
          }}>
            {t('Профиль')}
          </Button>
        </div>
      )
    }
  }
  return (
    <>
      <Card
        style={{ width: 300 }}
        actions={buttons}
      >
        <Card.Meta
          style={{ display: "flex", alignItems: "center" }}
          avatar={guild.icon ? <Avatar src={`https://cdn.discordapp.com/icons/${guild.id}/${guild.icon}.png`} /> : <div style={{ height: 32 }}></div>}
          title={guild.name}
        />
      </Card>
    </>
  )
}